(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kt-home-shop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kt-home-shop')) {
    customElements.define('kt-home-shop', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const list = this.querySelector('[data-shop-tabs]');
        const tabs = [...this.querySelectorAll('[data-shop-tab]')];
        const panels = [...this.querySelectorAll('[data-shop-panel]')];
        if (!list || !tabs.length) return;
        list.setAttribute('role', 'tablist');
        const activate = (tab, focus = false) => {
          tabs.forEach(item => {
            const active = item === tab;
            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;
            item.classList.toggle('is-active', active);
          });
          panels.forEach(panel => { panel.hidden = panel.id !== tab.dataset.shopTab; });
          if (focus) tab.focus();
        };
        tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', tab.dataset.shopTab);
          const panel = panels.find(item => item.id === tab.dataset.shopTab);
          if (panel) {
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', tab.id);
            panel.tabIndex = 0;
          }
          tab.addEventListener('click', event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            activate(tab);
          });
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next !== undefined) {
              event.preventDefault();
              activate(tabs[next], true);
            } else if (event.key === ' ') {
              event.preventDefault();
              activate(tab);
            }
          });
        });
        activate(tabs[0]);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kt-merino-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kt-merino-story')) {
    customElements.define('kt-merino-story', class extends HTMLElement {
      connectedCallback() {
        if (this.motionObserver || this.dataset.animation !== 'true' || !('IntersectionObserver' in window)) return;
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = false;
        this.changePreference = () => this.updateMotion();
        this.motionPreference.addEventListener('change', this.changePreference);
        this.motionObserver = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.updateMotion();
        }, { threshold: 0.15 });
        this.motionObserver.observe(this.querySelector('.kt-merino__portrait'));
        this.updateMotion();
      }
      updateMotion() {
        if (this.motionPreference.matches || !this.inView) {
          window.clearTimeout(this.motionTimer);
          this.dataset.motion = 'paused';
          return;
        }
        if (this.motionPlayed) return;
        this.motionPlayed = true;
        this.dataset.motion = 'playing';
        this.motionTimer = window.setTimeout(() => {
          this.dataset.motion = 'paused';
        }, 4500);
      }
      disconnectedCallback() {
        window.clearTimeout(this.motionTimer);
        this.motionObserver?.disconnect();
        this.motionPreference?.removeEventListener('change', this.changePreference);
        this.dataset.motion = 'paused';
        this.motionObserver = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
